import api from "@/lib/api";

// Het formulier dat op dit moment open staat (één tegelijk). Wordt enkel naar de server geschreven
// op het moment van een automatische afmelding, zodat er geen half werk verloren gaat.
let current = null;

export function setCurrentDraft(draft) { current = draft; }
export function clearCurrentDraft() { current = null; }

export async function saveDraftNow(reason = "idle") {
  if (!current) return false;
  try { await api.put("/me/draft", { ...current, reason }); return true; }
  catch { return false; }
}
